import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Navbar from './Navbar';

function PrivateRoute() {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  const isAuthenticated = token && user;

  if (!isAuthenticated) return <Navigate to="/login" />;

  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
}

export default PrivateRoute;
